'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = 'M128 368l-128 0 0-368 384 0 0 368-128 0 0 144-128 0 0-144zm0-16l16 0 0 144 96 0 0-144 128 0 0-80-352 0 0 80 112 0zm240-96l0-240-96 0 0 96-16 0 0-96-64 0 0 80-16 0 0-80-80 0 0 112-16 0 0-112-64 0 0 240 352 0zM208 448c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;